import React, { useState } from 'react'
import { useFetch } from 'use-http'

import { Box, Button, Card, Heading, Text } from '@myxplor/stardust'

import { ServiceDetail } from './types'

import TabletLoginModal from './TabletLoginModal'

interface Props {
  service: ServiceDetail
}

const TabletLogin = ({ service }: Props) => {
  const [isModalOpen, setModalOpen] = useState<boolean>(false)

  const { account, id } = service

  const resetRequest = useFetch(`/api/v1/services/${id}/tablet_password_reset`)

  const onPasswordReset = async () => {
    await resetRequest.post()

    setModalOpen(true)
  }

  return (
    <Card>
      <Box display="flex" flexDirection="column">
        <Box alignItems="center" display="flex" justifyContent="space-between" padding="small">
          <Heading level={5}>Tablet Login</Heading>
          <Button onClick={onPasswordReset}>Reset Tablet Password</Button>
        </Box>
        <Box borderColor="lowestEmphasis" border="1px solid" padding="small">
          <Text>Username: {`${account.fkey_namespace.replace(':', '').toLowerCase()}-${id}`}</Text>
        </Box>
      </Box>
      <TabletLoginModal isOpen={isModalOpen} service={service} onCancel={() => setModalOpen(false)} />
    </Card>
  )
}

export default React.memo(TabletLogin)
